import { Box } from "@repo/components/src/ui/box";
import React from "react";

type Props = {
  /** A metric token color, i.e. `rgb(var(--color-chart-…))`. */
  color: string;
  size?: number;
};

/**
 * Legend/chip dot for a metric.
 *
 * Drawn as an inline SVG rather than a `Box` with `backgroundColor`: React
 * Native Web normalises style colors and drops `rgb(var(--x))`, so a themed
 * token set that way renders transparent — the dot vanished while still
 * occupying its width, which is what pushed every chip label off centre. SVG
 * `fill` is passed through untouched, the same trick `brandImpactSection`'s
 * `LegendSwatch` already uses. Never set a themed token via `style`.
 */
const MetricDot = React.memo(({ color, size = 8 }: Props) => (
  <Box style={{ width: size, height: size } as object}>
    <svg viewBox="0 0 8 8" width={size} height={size}>
      <circle cx={4} cy={4} r={4} fill={color} />
    </svg>
  </Box>
));

MetricDot.displayName = "MetricDot";

export default MetricDot;
